export type MetricKey = 'handled' | 'resolved' | 'escalated';

export const METRICS: {
  key: MetricKey;
  label: string;
  swatchClass: string;
  strokeClass: string;
}[] = [
  {
    key: 'handled',
    label: 'Handled',
    swatchClass: 'h-0.5 w-3 rounded-full bg-slate-500 dark:bg-slate-300',
    strokeClass: 'stroke-slate-500 dark:stroke-slate-300',
  },
  {
    key: 'resolved',
    label: 'Resolved',
    swatchClass: 'h-0.5 w-3 rounded-full bg-teal-600 dark:bg-teal-400',
    strokeClass: 'stroke-teal-600 dark:stroke-teal-400',
  },
  {
    key: 'escalated',
    label: 'Escalated',
    swatchClass: 'h-2 w-2 rounded-full bg-amber-500',
    strokeClass: 'stroke-amber-500',
  },
];
